import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ParseService } from 'app/shared/common/parse/parse.service';
import { HardCodedValues } from 'app/shared/common/hard-coded-values';
import { DateServiceService } from 'app/shared/common/helper/dateservice';
import { TreeNode, SelectItem } from 'primeng/primeng';
import { MatTableDataSource, MatDialog, MatDatepicker } from '@angular/material';
import { WorkElement, BreakElement } from 'app/shared/common/interface';
import { Lightbox } from 'ngx-lightbox';
import { StorageConfiguration } from 'app/shared/common/storage-setting/storage-configuration';
import { DatePipe } from '@angular/common';
import { ViolationModel } from 'app/shared/violation-interface';
import moment, { default as _rollupMoment, Moment } from 'moment';
import { fuseAnimations } from '@fuse/animations';
import { NgxSpinnerService } from 'ngx-spinner';
import { ActivatedRoute, Router } from '@angular/router';
import { GetReportingToService } from 'app/shared/common/helper/get-reporting-to';
import { SocketService } from 'app/shared/common/helper/socket.service';
import { QueryInterface } from 'app/shared/common/parse/query-interface';


@Component({
  selector: 'app-my-team',
  templateUrl: './my-team.component.html',
  styleUrls: ['./my-team.component.scss'],
  providers: [DatePipe],
  animations: fuseAnimations
})
export class MyTeamComponent implements OnInit {

  contacts: any[];
  chat: any;
  selectedContact: any;
  sidebarFolded: boolean;
  user: any;
  contactsList = [];
  selectedNode: TreeNode;
  nodes: any;
  teamMembers = [];
  teamLeadName: any;
  last5days = [];
  imageDetails: any[];
  images = [];
  screenShotImage = [];
  selectedDate = new Date();
  selectedLeaderProfileId: any;
  selectedResourceId: any;
  dataSource1 = new MatTableDataSource(workData);
  dataSource2 = new MatTableDataSource(breakData);
  displayedColumns: string[] = ['WorkProject', 'WorkTimeIn', 'WorkTimeOut', 'WorkHours'];
  displayedColumnsnew: string[] = ['BreakTimeIn', 'BreakTimeOut', 'BreakHours', 'Comments', 'Reasons'];
  startTime: any;
  outTime: any;
  isClosed: boolean;
  startingTime: any;
  graceStartTime: any;
  inTime: Date;
  noTable = true;
  noData = false;
  firstTimeofday: any;
  lastTimeofday: any;
  selectedTeamMembers: any;
  // Private
  empRole: any;
  reportingList = [];
  reportingToDD = [];
  reportingToOptions: SelectItem[];

  violationsData: ViolationModel[] = [];
  selectbydate = new Date();
  selectedMonth: any;
  maxWorkingDays = 0;
  selectedStatus = 'all';
  inTimeCount = 0;
  inCompletedHrsCount = 0;
  breakHrsCount = 0;
  name: string;
  violationDate: Date = new Date();
  activities = [];
  userActivities = [];
  tabIndex = new FormControl(0);

  hide = true;
  dedicatedBillable: any;
  fixedBillable: any;
  nonBillable: any;
  nonWorkingDays = [];
  workingDays: any;
  currentDate = new Date();
  formDate = new FormControl(moment());
  filteredDate: Date;
  profileId: any;
  teamLeaderProfileId: any;
  noReportinPersons = false;
  selectedTeam = '';
  selectedTab = 'Profile Info';
  profileImage = '';
  profileName = '';
  roleName = '';
  userStatus = '';
  totalReportingPersons = 0;
  tenantId: any;
  tenantRole: any;
  tenantDepartment: any;
  teamMembersCount: number = 0;
  teamMemberProfileDetails: any = [];
  skillsShow: boolean = false;
  workHoursInfo: any[];
  breakHoursInfo: any[];
  isCheckIn: boolean;
  checkInWorkHours: string;
  checkInTime: any;
  checkOutTime: any;
  checkOutWorkHours: string;

  constructor(
    private parseService: ParseService,
    private hardCodedValues: HardCodedValues,
    private dateService: DateServiceService,
    private _lightbox: Lightbox,
    public dialog: MatDialog,
    private storageConfiguration: StorageConfiguration,
    private spinner: NgxSpinnerService,
    private route: ActivatedRoute,
    private getReportingToService: GetReportingToService,
    private router: Router,
    private _socket: SocketService,
    private queryInterface: QueryInterface,
    private datePipe: DatePipe
  ) {

  }

  async ngOnInit() {
    this.tenantId = this.storageConfiguration.sessionGetItem(this.storageConfiguration.tenantId);
    this.empRole = this.storageConfiguration.sessionGetItem(this.storageConfiguration.role);
    this.profileId = this.parseService.instance.User.current().get('profile').id;
    this.hide = true;
    this.spinner.show();
    this.getTenantDepartment();
    this.getTenantRole();
    await this.getContactsList();
    await this.getReportingTo();
    await this.getWorkingDays(new Date());

    this.route.params.subscribe(params => {
      this.teamLeaderProfileId = params.id;
      if (this.teamLeaderProfileId != undefined) {
        this.selectedLeaderProfileId = this.teamLeaderProfileId;
        this.selectedResourceId = this.selectedLeaderProfileId;
        this.selectedTeam = this.selectedLeaderProfileId;

        var queryProfile = new this.parseService.instance.Object('Profile');
        queryProfile.id = this.selectedLeaderProfileId;
        let profile = queryProfile.get('profileImageInfo');
        if (this.isEmpty(profile)) {
          this.profileImage = this.hardCodedValues.defaultProfileImg;
        }
        else {
          this.profileImage = queryProfile.get('profileImageInfo').url;
        }
        this.profileName = queryProfile.get('firstName') + ' ' + queryProfile.get('lastName');
        this.roleName = queryProfile.get('role').get('name');
        this.openTeamStatus();
      }
      if (this.empRole == 'Employee') {
        // this.router.navigate(['/user-timesheet']);
      }
    });

    var profileID = this.parseService.instance.User.current().get('profile').id;
    this.resourceDetailsInfo(profileID);

  }

  async getContactsList() {
    let profileClass = this.parseService.instance.Object.extend('Profile');
    let query = new this.parseService.instance.Query(profileClass);
    query.equalTo('isActive', true);
    query.include('location');
    query.include('department');
    query.include('role');
    query.include('organisation');
    query.equalTo('tenantId', this.tenantId);
    query.limit(10000000);
    query.find().then(async results => {
      let twilightEmployees = (results);
      let reporters = [];
      let ceo = twilightEmployees.filter(x => x.get('role').get('name') == 'CEO');

      if (this.empRole == 'Admin') {
        if (ceo.length > 0) {
          reporters = twilightEmployees.filter(x => x.get('reportingTo').id == ceo[0].id);
        }
      }
      if (this.empRole == 'Leader' || this.empRole == 'IT Manager') {
        reporters = twilightEmployees.filter(x => x.get('reportingTo').id == this.parseService.instance.User.current().get('profile').id);
      }

      let data = [];
      reporters.forEach(async element => {
        let dateDifferent = this.dateService.startEndDateByDate(new Date());
        let userClass = this.parseService.instance.Object.extend('UserTimeSheet');
        let query = new this.parseService.instance.Query(userClass);
        query.greaterThan('createdAt', dateDifferent[0]);
        query.lessThan('createdAt', dateDifferent[1]);
        query.include('profileId');
        query.include('profileId.location');
        query.equalTo('profileId', { __type: 'Pointer', className: 'Profile', objectId: element.id });
        await query.find().then(results => {
          data.push({
            name: element.get('firstName') + ' ' + element.get('lastName'),
            image: element.get('profileImageInfo').url ? element.get('profileImageInfo').url : this.hardCodedValues.defaultProfileImg,
            profileId: element.id,
            currentStatus: (results.length > 0) ? results[0].get('currentStatus') : 'Not logged in'
          });
        });
        this.contactsList = data;
      });
    });

    if (this.empRole == 'Admin' || this.empRole == 'Leader' || this.empRole == 'IT Manager') {
      this.selectedLeaderProfileId = this.profileId;
      this.selectedResourceId = this.selectedLeaderProfileId;
      this.openTeamStatus();
    }
    if (this.empRole == 'Employee') {
      let reporterId = await this.getReporterProfileId(this.profileId);
      this.selectedLeaderProfileId = reporterId.get('reportingTo').id;
      this.selectedResourceId = this.selectedLeaderProfileId;
      this.openTeamStatus();
    }

  }

  async getReporterProfileId(profileId) {
    let queryInstance = this.parseService.instance.Object.extend("Profile")
    let query = new this.parseService.instance.Query(queryInstance);
    query.equalTo("objectId", profileId);
    let results = await query.find();
    return results[0];
  }

  chooseTeam(event) {
    this.teamMemberProfileDetails = [];
    if (event.profileId != undefined) {
      this.selectedLeaderProfileId = event.profileId;
      this.selectedResourceId = this.selectedLeaderProfileId;
    }
    if (event.value != undefined) {
      this.selectedLeaderProfileId = event.value;
      this.selectedResourceId = this.selectedLeaderProfileId;
    }
    this.resourceDetailsInfo(event.value);
    this.openTeamStatus();
  }

  async openTeamStatus() {
    let department = '';
    if (this.profileId != this.selectedLeaderProfileId) {
      this._socket.sendTimesheetNotification(this.selectedLeaderProfileId, this.selectedTab);
    }

    var queryProfile = new this.parseService.instance.Object('Profile');
    queryProfile.id = this.selectedLeaderProfileId;
    this.teamLeadName = queryProfile.get('firstName') + ' ' + queryProfile.get('lastName');

    this.last5Days();
    this.teamMembers = [];
    let profileClass = this.parseService.instance.Object.extend('Profile');
    let query = new this.parseService.instance.Query(profileClass);
    query.equalTo('isActive', true);
    query.include('location');
    query.include('department');
    query.include('role');
    query.include('organisation');
    query.equalTo('reportingTo', { __type: 'Pointer', className: 'Profile', objectId: this.selectedLeaderProfileId });
    query.equalTo('tenantId', this.tenantId);
    query.limit(10000000);
    query.include('reportingTo');
    query.find().then(async results => {
      if (results.length > 0) {
        this.teamMembersCount = results.length;
        this.noReportinPersons = false;
        let twilightEmployees = (results);
        let childData = [];
        let name = results[0].get('reportingTo').get('firstName') + ' ' + results[0].get('reportingTo').get('lastName');

        twilightEmployees.forEach(async element => {
          let dateDifferent = this.dateService.startEndDateByDate(new Date());
          let userClass = this.parseService.instance.Object.extend('UserTimeSheet');
          let query = new this.parseService.instance.Query(userClass);
          query.greaterThan('createdAt', dateDifferent[0]);
          query.lessThan('createdAt', dateDifferent[1]);
          query.include('profileId');
          query.include('profileId.location');
          query.equalTo('profileId', { __type: 'Pointer', className: 'Profile', objectId: element.id });
          await query.find().then(results => {
            let exp: any = Number(`${element.get('officialInfo').experience.year.length > 0 ? element.get('officialInfo').experience.year : 0}.${element.get('officialInfo').experience.month, length > 0 ? element.get('officialInfo').experience.month : 0}`);
            childData.push({
              label: this.getReportingToService.getDepartmentDisplayName(element.get('department').get('name')),
              type: 'person',
              experience: exp,
              styleClass: 'ui-person',
              expanded: true,
              userName: element.get('firstName') + ' ' + element.get('lastName'),
              data: {
                name: element.get('firstName').charAt(0).toUpperCase() + ' ' + element.get('lastName').charAt(0).toUpperCase(),
                'avatar': element.get('profileImageInfo').url ? element.get('profileImageInfo').url : this.hardCodedValues.defaultProfileImg
              },
              profileId: element.id,
              currentStatus: (results.length > 0) ? results[0].get('currentStatus') : 'Not logged in'
            });
            childData = childData.sort((a, b) => { return b.experience - a.experience; });
          });
        });
        this.totalReportingPersons = twilightEmployees.length;

        let dateDifferent = this.dateService.startEndDateByDate(new Date());
        let userClass = this.parseService.instance.Object.extend('UserTimeSheet');
        let query = new this.parseService.instance.Query(userClass);
        query.greaterThan('createdAt', dateDifferent[0]);
        query.lessThan('createdAt', dateDifferent[1]);
        query.include('profileId');
        query.include('profileId.location');
        query.equalTo('profileId', { __type: 'Pointer', className: 'Profile', objectId: queryProfile.id });
        await query.find().then(results => {
          this.selectedTeamMembers = [{
            label: queryProfile.get('role').get('name'),
            type: 'person',
            styleClass: 'ui-person',
            expanded: true,
            data: { name: name, 'avatar': queryProfile.get('profileImageInfo').url ? queryProfile.get('profileImageInfo').url : this.hardCodedValues.defaultProfileImg },
            children: childData,
            profileId: queryProfile.id,
            currentStatus: (results.length > 0) ? results[0].get('currentStatus') : 'Not logged in'
          }];
          this.last5DaysTimesheet(new Date(), this.selectedLeaderProfileId);
          this.last5DaysScreenShots(new Date(), this.selectedLeaderProfileId);
          this.getEmployeeViolations(this.selectedStatus);
          this.getActivities();
          this.getResourceStatus(new Date());
        });
      }
      else {
        this.noReportinPersons = true;
        let noProfile = new this.parseService.instance.Object('Profile');
        noProfile.id = this.selectedLeaderProfileId;
        let profile = noProfile.get('profileImageInfo');
        if (this.isEmpty(profile)) {
          this.profileImage = this.hardCodedValues.defaultProfileImg;
        }
        else {
          this.profileImage = noProfile.get('profileImageInfo').url;
        }
        this.profileName = noProfile.get('firstName') + ' ' + noProfile.get('lastName');
        this.roleName = noProfile.get('role').get('name');

        let dateDifferent = this.dateService.startEndDateByDate(new Date());
        let userClass = this.parseService.instance.Object.extend('UserTimeSheet');
        let query = new this.parseService.instance.Query(userClass);
        query.greaterThan('createdAt', dateDifferent[0]);
        query.lessThan('createdAt', dateDifferent[1]);
        query.include('profileId');
        query.equalTo('profileId', { __type: 'Pointer', className: 'Profile', objectId: this.selectedLeaderProfileId });
        let results = await query.find();
        this.userStatus = (results.length > 0) ? results[0].get('currentStatus') : 'Not logged in';

        this.last5DaysTimesheet(new Date(), this.selectedLeaderProfileId);
        this.last5DaysScreenShots(new Date(), this.selectedLeaderProfileId);
        this.getEmployeeViolations(this.selectedStatus);
        this.getActivities();
        this.getResourceStatus(new Date());
      }
    });
    this.spinner.hide();
  }

  onNodeSelect(event) {
    this.selectedTab = 'Profile Info';
    /**
     * * Not allowed to call below function if role equal to Employee
     */
    if (this.empRole === 'Employee') {
      return;
    }
    this.tabIndex.setValue(0);
    this.selectedResourceId = event.node.profileId;
    this.last5DaysScreenShots(new Date(), event.node.profileId);
    this.last5DaysTimesheet(new Date(), event.node.profileId);
    this.getEmployeeViolations(this.selectedStatus);
    this.getActivities();
    this.getResourceStatus(this.filteredDate);
    this.resourceDetailsInfo(event.node.profileId);
    // this.getCheckInCheckOutInfo(new Date(), event.node.profileId);
    if (this.profileId != this.selectedResourceId) {
      this._socket.sendTimesheetNotification(this.selectedResourceId, this.selectedTab);
    }
  }

  async resourceDetailsInfo(profileId: string) {
    let profileClass = this.parseService.instance.Object.extend('Profile');
    let query = new this.parseService.instance.Query(profileClass);
    query.equalTo('isActive', true);
    query.include('location');
    query.include('department');
    query.include('role');
    query.include('organisation');
    query.equalTo('objectId', profileId);
    query.equalTo('tenantId', this.tenantId);
    query.limit(10000000);
    query.include('reportingTo');
    let results = await query.find()
    if (results.length > 0) {
      this.teamMemberProfileDetails = [];
      for (let user of results) {
        if (Object.keys(user.get('profileImageInfo')).length > 0) { var profileImg = user.get('profileImageInfo').url ? user.get('profileImageInfo').url : '../../../../assets/images/avatars/profile.jpg'; }
        else { var profileImg: any = '../../../../assets/images/avatars/profile.jpg'; }

        if (Object.keys(user.get('personalInfo')).length > 0) {
          var phoneNumber = user.get('personalInfo').mobileNo ? user.get('personalInfo').mobileNo : '';
        }

        if (Object.keys(user.get('officialInfo').length > 0)) {
          var doj = user.get('officialInfo').reportingDate ? user.get('officialInfo').reportingDate : '-';
        }
        if (user.get('skillSet').length > 0) {
          this.skillsShow = true;
        }
        let userInfo = {
          profileImg: profileImg,
          name: user.get('username') ? user.get('username') : '',
          email: user.get('email') ? user.get('email') : '',
          phoneNumber: phoneNumber,
          designation: user.get('role').get('name'),
          doj: doj != "-" ? this.datePipe.transform(doj, 'MMM d, y') : '-',
          experiences: `${user.get('officialInfo').experience.year} Year ${user.get('officialInfo').experience.month} Months `,
          skills: user.get('skillSet')
        }
        this.teamMemberProfileDetails.push(userInfo);
      }
    }
  }

  last5DaysTimesheet($event, profileId) {
    this.selectedDate = this.last5days[$event];
    this.getTimesheet(this.selectedDate, profileId);
  }

  getTimesheet(selectbydate, profileId) {
    if (selectbydate == undefined) {
      this.selectedDate = new Date();
    }

    let userTimesheet = this.parseService.instance.Object.extend('UserTimeSheet');
    let query = new this.parseService.instance.Query(userTimesheet);
    let date = selectbydate != undefined ? selectbydate : new Date();
    let startend = this.startenddates(date);
    query.equalTo('profileId', { __type: 'Pointer', className: 'Profile', objectId: this.selectedResourceId });
    query.descending('createdAt');
    query.greaterThan('createdAt', startend[0]);
    query.lessThan('createdAt', startend[1]);
    query.find().then(results => {
      if (results.length == 0) {
        this.noData = true;
        this.noTable = false;
        this.dataSource1 = new MatTableDataSource(workData);
        this.dataSource2 = new MatTableDataSource(breakData);
        this.firstTimeofday = 0;
        this.lastTimeofday = 0;
      }
      else if (results.length == 1) {
        this.noData = false;
        this.noTable = true;
        let attendance = results[0];
        let workTime = attendance.get('workTime');
        let breakTime = attendance.get('breakTime');
        this.startingTime = attendance.get('agreedStartTime');
        this.formatStartTime(date.toISOString());
        this.inTime = new Date(attendance.get('inTime'));
        this.outTime = attendance.get('outTime');
        this.isClosed = attendance.get('isClosed');
        let totalAttendance = attendance.get('totalAttendance');
        this.displayEvent(workTime, breakTime);
        this.firstTimeofday = this.secondsToHms(totalAttendance.worktime);
        this.lastTimeofday = this.secondsToHms(totalAttendance.breaktime);
      }
    });
  }

  last5DaysScreenShots($event, profileId) {
    this.selectedDate = this.last5days[$event];
    this.getScreenshotImage(this.selectedDate, profileId);
  }

  getScreenshotImage(selectbydate, profileId) {
    if (selectbydate == undefined) {
      this.selectedDate = new Date();
    }
    this.imageDetails = [];
    let img = '';
    this.images = [];
    let description = '';
    let queryInstance = this.parseService.instance.Object.extend('UserScreenShots');
    let query = new this.parseService.instance.Query(queryInstance);
    let date = selectbydate != undefined ? selectbydate : new Date();
    let startend = this.startenddates(date);
    query.descending('createdAt');
    query.greaterThan('createdAt', startend[0]);
    query.lessThan('createdAt', startend[1]);
    query.include('profileId');
    query.equalTo('profileId', { __type: 'Pointer', className: 'Profile', objectId: this.selectedResourceId });
    query.find().then(results => {
      results.forEach(element => {
        this.imageDetails = element.get('imageDetails');
        this.imageDetails.forEach(innerElement => {
          img = innerElement.apiUrl;
          let recordedTime = (new Date(innerElement.recordedTime));
          description = 'Screenshot';
          this.images.push({
            src: img,
            caption: recordedTime,
            thumb: img
          });
        });
      });
      this.screenShotImage = this.images;
    });
  }

  formatStartTime(date) {
    var datePipe = new DatePipe('en-US');
    let startDate = datePipe.transform(date, 'MM/dd/yyyy');
    this.startTime = new Date(startDate + ' ' + this.startingTime);
    this.graceStartTime = new Date(new Date(startDate + ' ' + this.startingTime).getTime() + (16 * 60 * 1000));
  }

  /*
  ** ==========================================================
  ** Data Binding Function
  ** ==========================================================
  */

  displayEvent(workTime, breakTime) {
    let project = null, inTime = null, outTime = null, actualHours = null, breakHours = null, reasonobj = null,
      elt = null, reasonname = null, reasonComment1 = null, reasonComment2 = null, breakData = [];
    this.dataSource2 = new MatTableDataSource(breakData);
    workData = [];
    this.dataSource1 = new MatTableDataSource(workData);
    for (let i = 0; i < workTime.length; i++) {
      elt = workTime[i];
      inTime = this.time(new Date(elt.inTime));
      outTime = null;
      actualHours = null;
      project = null;
      if (
        elt.outTime != 0 && elt.outTime != null &&
        elt.actualHours != 0 && elt.actualHours != null &&
        elt.project != null
      ) {
        outTime = this.time(new Date(elt.outTime));
        actualHours = this.secondsToHms(Math.ceil(elt.actualHours / 1000));
        project = elt.project.name;

        workData.push({
          WorkProject: project,
          WorkTimeIn: inTime,
          WorkTimeOut: outTime,
          WorkHours: actualHours
        });
      }
      this.dataSource1 = new MatTableDataSource(workData);
    }
    for (let i = 0; i < breakTime.length; i++) {
      elt = breakTime[i];
      outTime = this.time(new Date(elt.outTime));
      (inTime = null),
        (breakHours = null),
        (reasonobj = null),
        (reasonname = null);
      (reasonComment1 = null);
      (reasonComment2 = null);
      if (elt.inTime != 0 && elt.inTime != null &&
        elt.breakHours != 0 && elt.breakHours != null &&
        elt.reason != null) {
        inTime = this.time(new Date(elt.inTime));
        breakHours = this.secondsToHms(Math.ceil(elt.breakHours / 1000));
        reasonobj = elt.reason;
        reasonname = reasonobj.reason;
        let reason = '';
        if (reasonname == 'Other') {
          reason = reasonobj.other;
        } else {
          reasonComment1 = reasonobj.subject == undefined ? '' : reasonobj.subject;
          reasonComment2 = reasonobj.withWho == undefined ? '' : reasonobj.withWho;
          reason = (reasonComment1 == '' && reasonComment2 == '') ? '' : reasonComment1.concat(' with ' + reasonComment2);
        }
        breakData.push({
          BreakTimeIn: outTime,
          BreakTimeOut: inTime,
          BreakHours: breakHours,
          Comments: reasonname,
          Reasons: reason
        });
      }
      this.dataSource2 = new MatTableDataSource(breakData);
    }
  }

  last5Days() {
    var result = [];
    for (var i = 0; i < 10; i++) {
      var d = new Date();
      d.setDate(d.getDate() - i);
      result.push(d);
    }
    this.last5days = result;
  }

  time(d) {
    return d.toLocaleString('en-US', {
      hour: 'numeric',
      minute: 'numeric',
      hour12: true
    });
  }

  open(index: number): void {
    // open lightbox
    this._lightbox.open(this.screenShotImage, index);
  }

  close(): void {
    // close lightbox programmatically
    this._lightbox.close();
  }

  startenddates(day) {
    let startdate = this.daybefore(new Date(day));
    startdate.setHours(23, 59, 59, 999);
    let enddate = this.dayafter(day);
    enddate.setHours(0, 0, 0, 0);
    return [startdate, enddate];
  }

  dayafter(d) {
    let day = new Date(d);
    return new Date(day.setDate(day.getDate() + 1));
  }

  daybefore(d) {
    let day = new Date(d);
    return new Date(day.setDate(day.getDate() - 1));
  }

  closeDialog() {
    this.dialog.closeAll();
  }

  secondsToHms(d) {
    d = Number(d);
    var h = Math.floor(d / 3600);
    var m = Math.floor(d % 3600 / 60);
    var s = Math.floor(d % 3600 % 60);

    var hDisplay = (h <= 9 ? '0' : '') + h;
    var mDisplay = (m <= 9 ? '0' : '') + m;
    var sDisplay = (s <= 9 ? '0' : '') + s;
    return hDisplay + ':' + mDisplay + ':' + sDisplay;
  }

  async getReportingTo() {

    await this.getReportingToService.getReportingTo().then(async res => {
      this.reportingToDD = this.bindDropDown(res);
    });
  }

  bindDropDown(array: any[]): any[] {
    const dropDownItem = [];
    array.forEach(a => {
      dropDownItem.push({ id: a.value, name: a.label });
    });
    return dropDownItem;
  }


  date = new FormControl(moment());
  chosenYearHandler(normalizedYear: Moment) {
    const ctrlValue = this.date.value;
    ctrlValue.year(normalizedYear.year());
    this.date.setValue(ctrlValue);
  }

  chosenMonthHandler(normalizedMonth: Moment, datepicker: MatDatepicker<Moment>) {
    const ctrlValue = this.date.value;
    ctrlValue.month(normalizedMonth.month());
    this.date.setValue(ctrlValue);
    datepicker.close();
    this.violationDate = this.date.value._d;
    this.getWorkingDays(this.date.value._d);
    this.getEmployeeViolations(this.selectedStatus);
  }

  getWorkingDays(event) {
    var date = new Date(event);
    var month = date.getMonth();
    var year = date.getFullYear();
    date = new Date(year, month, 1);
    var days = [];
    while (date.getMonth() === month) {
      // Exclude weekends
      var tmpDate = new Date(date);
      var weekDay = tmpDate.getDay(); // week day
      var day = tmpDate.getDate(); // day

      if (weekDay % 6) { // exclude 0=Sunday and 6=Saturday
        days.push(day);
      }
      date.setDate(date.getDate() + 1);
    }
    this.maxWorkingDays = days.length + 2;
  }


  getEmployeeViolations(status) {
    if (status == '') {
      status = 'all';
      this.selectedStatus = 'all';
    }
    this.violationsData = [];
    let startend = this.violationStartenddates(this.violationDate);
    let queryInstance = this.parseService.instance.Object.extend('UserViolations');
    let query = new this.parseService.instance.Query(queryInstance);
    query.include('userProfileId');
    query.include('reportingTo');
    query.include('userProfileId.role');
    query.greaterThan('violatedDate', startend[0]);
    query.lessThan('violatedDate', startend[1]);
    query.descending('updatedAt');
    if (status != 'all') {
      query.equalTo('status', status);
    }
    query.equalTo('userProfileId', { __type: 'Pointer', className: 'Profile', objectId: this.selectedResourceId });
    query.find().then(results => {
      let violations = [];
      results.forEach(element => {
        let violate: ViolationModel = new ViolationModel();
        let vDate = element.get('violatedDate');
        violate.violatedDate = new Date(vDate);
        violate.userProfileId = element.get('userProfileId');
        this.name = violate.userProfileId.get('firstName') + ' ' + violate.userProfileId.get('lastName');
        violate.startTime = element.get('userProfileId').get('officialInfo').startTime;
        violate.violations = element.get('violations');
        violate.status = element.get('status');
        violate.reportingTo = element.get('reportingTo');
        violate.resolvedBy = element.get('resolvedBy');
        violate.resolvedDate = element.get('resolvedDate');
        violate.objectId = element.id;
        violations.push(violate);
      });
      this.violationsData = violations;
      this.inTimeCount = 0;
      this.inCompletedHrsCount = 0;
      this.breakHrsCount = 0;
      violations.forEach(element => {
        element.violations.forEach(innerElement => {
          if (innerElement.type == 'In-Time') {
            this.inTimeCount += 1
          }
          if (innerElement.type == 'Incompleted-Hours') {
            this.inCompletedHrsCount += 1
          }
          if (innerElement.type == 'Exceeded-Break-Hours') {
            this.breakHrsCount += 1
          }
        });
      });
    });
  }

  violationStartenddates(day) {
    let startdate = this.violationDaybefore(new Date(day));
    startdate.setHours(23, 59, 59, 999);
    let enddate = this.violationDayafter(day);
    enddate.setHours(0, 0, 0, 0);
    return [startdate, enddate];
  }

  violationDayafter(d) {
    let day = new Date(d);
    return new Date(day.getFullYear(), day.getMonth() + 1, 1);
  }

  violationDaybefore(d) {
    let day = new Date(d);
    return new Date(day.getFullYear(), day.getMonth(), 0);
  }

  getActivities() {
    let i = 0;
    let startend = this.violationStartenddates(this.violationDate);
    let queryInstance = this.parseService.instance.Object.extend('ActivityCenter');
    let query = new this.parseService.instance.Query(queryInstance);
    query.include('updatedBy');
    query.include('updatedBy.role');
    query.greaterThan('createdAt', startend[0]);
    query.lessThan('createdAt', startend[1]);
    query.descending('updatedAt');
    query.equalTo('updatedBy', { __type: 'Pointer', className: 'Profile', objectId: this.selectedResourceId });
    query.find().then(async element => {
      this.activities = [];
      this.userActivities = [];
      let activity = [];
      element.forEach(async results => {
        let name;
        if (results.get('moduleType') == 'Project') {
          let queryInstance = this.parseService.instance.Object.extend('Project');
          let query = new this.parseService.instance.Query(queryInstance);
          query.equalTo('objectId', results.get('updatedId'));
          await query.find().then(res => {
            let projectResult = res[0];
            name = projectResult && projectResult.get('projectInfo') ? projectResult.get('projectInfo').projectName : '';
          });
        }
        if (results.get('moduleType') == 'Sub-Project') {
          let queryInstance = this.parseService.instance.Object.extend('Project');
          let query = new this.parseService.instance.Query(queryInstance);
          query.equalTo('objectId', results.get('updatedId'));
          await query.find().then(res => {
            let addonResult = res[0];
            name = addonResult.get('projectInfo').projectName;
          });
        }
        if (results.get('moduleType') == 'Client') {
          let queryInstance = this.parseService.instance.Object.extend('Client');
          let query = new this.parseService.instance.Query(queryInstance);
          query.equalTo('objectId', results.get('updatedId'));
          await query.find().then(res => {
            let clientResult = res[0];
            name = clientResult.get('companyInfo').firstName + ' ' + clientResult.get('companyInfo').lastName;
          });
        }
        if (results.get('moduleType') == 'Profile-View') {
          let queryInstance = this.parseService.instance.Object.extend('Profile');
          let query = new this.parseService.instance.Query(queryInstance);
          query.equalTo('objectId', results.get('updatedId'));
          query.equalTo('tenantId', this.tenantId);
          await query.find().then(res => {
            let profileResult = res[0];
            name = profileResult.get('firstName') + ' ' + profileResult.get('lastName');
          });
        }
        if (results.get('moduleType') == 'Sprint') {
          let queryInstance = this.parseService.instance.Object.extend('Sprint');
          let query = new this.parseService.instance.Query(queryInstance);
          query.equalTo('objectId', results.get('updatedId'));
          await query.find().then(res => {
            let sprintResult = res[0];
            name = sprintResult.get('name');
          });
        }
        i = i + 1;
        activity.push({
          position: i,
          message: results.get('message'),
          name: name,
          createdAt: results.get('createdAt')
        });
        this.userActivities = activity;
        this.activities = activity.slice(0, 10);;
      });
    });
  }

  nextPage(event) {
    let activity = this.userActivities;
    let start = event.pageIndex * event.pageSize;
    this.activities = activity.slice(start, start + event.pageSize);
  }

  async getResourceStatus(filterDate) {
    let userId = await this.getProfileId(this.selectedResourceId);
    this.getHolidays(filterDate);
    let user = this.parseService.instance.Object.extend('ResourceStatus');
    let query = new this.parseService.instance.Query(user);
    query.equalTo('user', { __type: 'Pointer', className: '_User', objectId: userId });
    let dateDifferent = this.dateService.startEndDateByMonth(filterDate ? filterDate : new Date());
    query.greaterThan('createdAt', dateDifferent[0]);
    query.lessThan('createdAt', dateDifferent[1]);
    query.limit(10000);
    let result = await query.find();
    this.dedicatedBillable = (result.filter(x => x.get('resourceStatus') == 'Dedicated Billable')).length;
    this.fixedBillable = (result.filter(x => x.get('resourceStatus') == 'Fixed Billable')).length;
    this.nonBillable = (result.filter(x => x.get('resourceStatus') == 'Non-Billable')).length;
  }

  async getHolidays(filterDate) {
    this.nonWorkingDays = [];
    var selectedDate = filterDate ? filterDate : new Date();
    var getTot = this.daysInMonth(selectedDate.getMonth() + 1, selectedDate.getFullYear());
    var currentMonth = new Array();
    for (let i = 1; i <= getTot; i++) {
      let newDate = new Date(selectedDate.getFullYear(), selectedDate.getMonth(), i)
      currentMonth.push(newDate);
    }

    for (let j = 0; j < currentMonth.length; j++) {
      let datesAll = new Date(selectedDate.getFullYear(), currentMonth[j].getMonth(), currentMonth[j].getDate());
      let dayOfWeek = datesAll.getDay();
      let dateOfMonth = datesAll.getDate();
      let isEvenWeek = Math.ceil(dateOfMonth / 7);
      let epochOddDates = datesAll.getTime();
      if (dayOfWeek == 0) {
        if (this.nonWorkingDays.indexOf(epochOddDates) === -1) {
          this.nonWorkingDays.push(new Date(epochOddDates));
        }
      } if (dayOfWeek == 6 && isEvenWeek % 2 != 0) {
        if (this.nonWorkingDays.indexOf(epochOddDates) === -1) {
          this.nonWorkingDays.push(new Date(epochOddDates));
        }
      }
    }

    const currentYear = selectedDate.getFullYear();
    const holidaysInstance = this.parseService.instance.Object.extend('Holidays');
    const holidayQuery = new this.parseService.instance.Query(holidaysInstance);
    holidayQuery.equalTo('year', currentYear);
    const leaveResults = await holidayQuery.find();
    if (leaveResults.length > 0) {
      let holidayList = leaveResults[0].get('dateList') == undefined ? {} : leaveResults[0].get('dateList');
      const allowed = [];
      allowed.push(String(selectedDate.getMonth()));
      const filtered = Object.keys(holidayList)
        .filter(key => allowed.includes(key))
        .reduce((obj, key) => {
          obj[key] = holidayList[key];
          return obj;
        }, {});
      let data = filtered[Object.keys(filtered)[0]];
      for (let k = 0; k < data.length; k++) {
        let newDate = new Date(selectedDate.getFullYear(), selectedDate.getMonth(), data[k]);
        this.nonWorkingDays.push((newDate));
      }
    }

    this.workingDays = currentMonth.length - this.nonWorkingDays.length;
  }

  chosenYear(normalizedYear: Moment): void {
    const ctrlValue = this.formDate.value;
    ctrlValue.year(normalizedYear.year());
    this.formDate.setValue(ctrlValue);
  }

  chosenMonth(normalizedMonth: Moment, datepicker: MatDatepicker<Moment>): void {
    const ctrlValue = this.formDate.value;
    ctrlValue.month(normalizedMonth.month());
    this.formDate.setValue(ctrlValue);
    let date = new Date(this.formDate.value);
    let filterDate = date.getMonth() == new Date().getMonth() ? new Date() : new Date(date.getFullYear(), date.getMonth() + 1, 0);
    this.filteredDate = filterDate;
    this.getResourceStatus(filterDate);
    datepicker.close();
  }

  async getProfileId(profileId) {
    let queryInstance = this.parseService.instance.Object.extend("User")
    let query = new this.parseService.instance.Query(queryInstance);
    query.equalTo("profile", { __type: "Pointer", className: "Profile", objectId: profileId });
    let results = await query.find();
    return results[0].id;
  }

  removeDuplicates(arr1, arr2) {
    return [...new Set(arr1.concat(arr2).filter(e => !(arr2.includes(e) && arr1.includes(e))))];
  }

  daysInMonth(month, year) {
    return new Date(year, month, 0).getDate();
  }

  tabChange(event) {
    this.selectedTab = event.tab.textLabel;
    this.sendNotification();
    if (event.tab.textLabel == 'Violations' || event.tab.textLabel == 'Activities' || event.tab.textLabel == 'Resource Status' || event.tab.textLabel.Timesheet) {
      this.hide = false;
    }
    else {
      this.hide = true;
    }
  }

  sendNotification() {
    if (this.profileId != this.selectedResourceId) {
      this._socket.sendTimesheetNotification(this.selectedResourceId, this.selectedTab);
    }
  }

  isEmpty(obj) {
    for (var key in obj) {
      if (obj.hasOwnProperty(key))
        return false;
    }
    return true;
  }

  async getTenantRole(): Promise<void> {
    this.tenantRole = await this.getReportingToService.getTenantRole(this.tenantId);
  }

  async getTenantDepartment(): Promise<void> {
    this.tenantDepartment = await this.getReportingToService.getTenantDepartment(this.tenantId);
  }

  async getCheckInCheckOutInfo(date, profileId?) {

    this.workHoursInfo = [];
    this.breakHoursInfo = [];
    this.isCheckIn = false;
    this.checkInWorkHours = '00:00:00';
    this.checkInTime = '00:00:00';
    this.checkOutTime = '00:00:00';
    this.checkOutWorkHours = '00:00:00';

    let queryInstance = this.parseService.instance.Object.extend('CheckInCheckout');
    let query = new this.parseService.instance.Query(queryInstance);

    let startend = this.startenddates(new Date(date));
    query.greaterThan('checkInDate', startend[0]);
    query.lessThan('checkInDate', startend[1]);

    query.equalTo('profile', { __type: 'Pointer', className: 'Profile', objectId: profileId });
    let checkInCheckoutInfo = await query.find();
    if (checkInCheckoutInfo.length > 0) {
      this.isCheckIn = true;

      this.checkInWorkHours = checkInCheckoutInfo[0].get('totalWorkHours') ? checkInCheckoutInfo[0].get('totalWorkHours') : '00:00:00';
      this.checkOutWorkHours = checkInCheckoutInfo[0].get('totalBreakHours') ? checkInCheckoutInfo[0].get('totalBreakHours') : '00:00:00';
      this.checkInTime = new Date(checkInCheckoutInfo[0].get('inTime'));
      // this.checkOutTime = new Date(checkInCheckoutInfo[0].get('outTime'));

      let inOutInfo = checkInCheckoutInfo[0].get('InOut');

      if (inOutInfo[inOutInfo.length - 1].direction == 'in') {


        let lastOutTime = new Date(inOutInfo[inOutInfo.length - 2].logDate).getTime();
        let convertIstTimeFormat = new Date(lastOutTime);
        convertIstTimeFormat.setHours(convertIstTimeFormat.getHours() - 5);
        convertIstTimeFormat.setMinutes(convertIstTimeFormat.getMinutes() - 30);

        this.checkOutTime = convertIstTimeFormat;
      }
      else if (inOutInfo[inOutInfo.length - 1].direction == 'out') {
        let lastOutTime = new Date(inOutInfo[inOutInfo.length - 1].logDate).getTime();
        let convertIstTimeFormat = new Date(lastOutTime);
        convertIstTimeFormat.setHours(convertIstTimeFormat.getHours() - 5);
        convertIstTimeFormat.setMinutes(convertIstTimeFormat.getMinutes() - 30);
        this.checkOutTime = convertIstTimeFormat;
      }

      this.workHoursInfo = [];
      this.breakHoursInfo = [];

      var i = 0;
      var j = 0;

      for (let data of checkInCheckoutInfo[0].get('InOut')) {

        var outTime = new Date(data.logDate).getTime();
        var convertIstTimeFormat = new Date(outTime);
        convertIstTimeFormat.setHours(convertIstTimeFormat.getHours() - 5);
        convertIstTimeFormat.setMinutes(convertIstTimeFormat.getMinutes() - 30);

        if (data.direction == 'in') {
          var checkInCheckoutDetails: any = {
            inTime: convertIstTimeFormat,
            inDirection: data.direction
          }
        }
        else if (data.direction == 'out') {
          i = i + 1;
          checkInCheckoutDetails.outDirection = data.direction;
          checkInCheckoutDetails.outTime = convertIstTimeFormat;
          checkInCheckoutDetails.position = i;

          let reamingHours = this.remainingHours(checkInCheckoutDetails.inTime, checkInCheckoutDetails.outTime);
          checkInCheckoutDetails.totalWorkHour = reamingHours;
          this.workHoursInfo.push(checkInCheckoutDetails);
          checkInCheckoutDetails = {};
        }

        if (data.direction == 'in' && checkInCheckoutInfo[0].get('InOut')[0] != data) {
          j = j + 1;
          checkInCheckoutBreak.inDirection = data.direction;
          checkInCheckoutBreak.inTime = convertIstTimeFormat;
          checkInCheckoutBreak.position = j;

          let breakHours = this.remainingHours(checkInCheckoutBreak.outTime, checkInCheckoutBreak.inTime);
          checkInCheckoutBreak.totalBreakHour = breakHours;
          this.breakHoursInfo.push(checkInCheckoutBreak);
          checkInCheckoutBreak = {};
        }
        else if (data.direction == 'out' && checkInCheckoutInfo[0].get('InOut')[checkInCheckoutInfo[0].get('InOut').length - 1] != data) {
          var checkInCheckoutBreak: any = {
            outTime: convertIstTimeFormat,
            outDirection: data.direction
          }
        }
      }

    }
  }

  remainingHours(checkIn, checkOut) {
    let remainHours = checkOut - checkIn;
    let hour: any = Math.abs(Math.floor((remainHours % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)));
    let minutes: any = Math.abs(Math.floor((remainHours % (1000 * 60 * 60)) / (1000 * 60)));
    if (minutes < 10) { minutes = '0' + minutes; }
    if (hour < 10) { hour = '0' + hour; }
    return `${hour}:${minutes}`;
  }

}


let workData: WorkElement[] = [];
let breakData: BreakElement[] = [];

